module.exports = __webpack_public_path__ + "static/media/Rajesh.4c3d0ef5.png";